import { ObjectSchema, object, string } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { Library } from './../../models/library';
yup.setLocale(locale);

export const libraryNameMaxLen = 50;

export function libraryValidator(): ObjectSchema<Library> {
    return object({
        id: string().uuid().nonNullable().strict(),
        shipyardId: string().uuid().nonNullable().strict(),
        name: string().nonNullable().strict().required().max(libraryNameMaxLen),
    })
        .strict()
        .noUnknown();
}
